/* ============================================================
   AlienGrafic · Filtros siempre abiertos (como el buscador)
   ------------------------------------------------------------
   Abre todos los grupos de filtros del layout vertical y los
   mantiene abiertos tras el re-render AJAX de Dawn. Usa el
   atributo open real (no CSS), para que el contenido se muestre.
   ============================================================ */
(function () {
  function openAll() {
    document.querySelectorAll('.facets__disclosure-vertical:not([open])').forEach(function (d) {
      d.open = true;
    });
  }

  function init() {
    var form = document.getElementById('FacetFiltersForm');
    if (!form) return;
    openAll();
    // Dawn reconstruye los facets al filtrar → los reabrimos
    new MutationObserver(openAll).observe(form, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();